import { render, staticRenderFns } from "./CaseContent.vue?vue&type=template&id=664246b1&"
import script from "./CaseContent.vue?vue&type=script&lang=js&"
export * from "./CaseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports